import { 
  AppBar, 
  Toolbar, 
  Box 
} from '@mui/material';
import './navbar.css';
import Logo from '../../assets/images/logo.png';
import { useState, useEffect } from 'react';

const Navbar = ({logo}) => {
    console.log(logo,"logo from navbar")
    
    // Only use the logo prop, no localStorage fallback
    const [brandLogo, setBrandLogo] = useState(logo);

    useEffect(() => {
        // Update brandLogo when logo prop changes
        if (logo) {
            setBrandLogo(logo);
        }
    }, [logo]);

    return (
        <AppBar
          position="sticky"
          sx={{
            boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
            height: {
              xs: 56,   // mobile
              sm: 60,   // tablet
              md: 70,   // desktop
            },
            justifyContent: 'center',
          }}
          className="appbarr"
        >
          <Toolbar
            sx={{
              minHeight: {
                xs: 56,
                sm: 60,
                md: 70,
              },
              px: { xs: 1, sm: 2, md: 3 },
              display: 'flex',
              justifyContent: {
                xs: 'center',
                sm: 'center',
                md: 'flex-start',
              },
            }}
          >
            <Box
              sx={{
                width: {
                  xs: 160,
                  sm: 180,
                  md: 240,
                },
                height: {
                  xs: 40,
                  sm: 45,
                  md: 50,
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: {
                  xs: 'center',
                  sm: 'center',
                  md: 'flex-start',
                },
                overflow: 'hidden',
              }}
            >
              {/* Only show logo if it exists */}
              {brandLogo && (
                <img
                  src={brandLogo}
                  alt="Company Logo"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </Box>
          </Toolbar>
        </AppBar>
    );
};

export default Navbar;
